<template>
  <b-field>
    <b-input ref="dlel" :class="{ size }" :value="value" expanded readonly autofocus></b-input>

    <p class="control">
      <button class="button is-primary" :class="{ size }" @click="copy(value)">
        <b-icon icon="content-copy" :class="{ size }"></b-icon>
      </button>
    </p>
  </b-field>
</template>

<script>
export default {
  props: ["value", "size"],

  methods: {
    copy(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$buefy.toast.open(`${this.value} <br/> Copied to your clipboard.`);
    }
  }
};
</script>
